import { create } from "zustand";

// Add interface for the API response
interface UserStatus {
  isAuthenticated: boolean;
  user?: {
    email: string;
    id: number;
    username: string;
    avatar: string;
    onboarding?: boolean;
  };
}

const useGoogleLoginStore = create((set) => ({
  userStatus: {
    isAuthenticated: false,
    user: undefined,
  },
  setUserStatus: (value: UserStatus) => set(() => ({ userStatus: value })),
  visible: false,
  setVisible: (value: boolean) => set(() => ({ visible: value })),
  authenticated: false,
  setAuthenticated: (value: boolean) => set(() => ({ authenticated: value })),
  successCallback: () => {},
  setSuccessCallback: (value: () => void) =>
    set(() => ({ successCallback: value })),
  cancelCallback: () => {},
  setCancelCallback: (value: () => void) =>
    set(() => ({ cancelCallback: value })),
  returnCallback: () => {},
  setReturnCallback: (value: () => void) =>
    set(() => ({ returnCallback: value })),
  onboardingModalVisible: false,
  setOnboardingModalVisible: (value: boolean) =>
    set(() => ({ onboardingModalVisible: value })),
  pendingRedirectUrl: null as string | null,
  setPendingRedirectUrl: (value: string | null) =>
    set(() => ({ pendingRedirectUrl: value })),
}));

export default useGoogleLoginStore;
